import Vue from 'vue'
import Vuex from 'vuex'
import App from './modules/common/app'
import User from './modules/common/user'
import Conditions from './modules/common/conditions'

Vue.use(Vuex)

const getters = {
    sidebar: state => state.app.sidebar,
    token: state => state.token,
    user: state => state.user,
    status: state => state.status,
}

const modules = {
    app: App,
    user: User,
    conditions: Conditions
}
export default new Vuex.Store({
    getters,
    modules
})
